import { useEffect } from "react";

const useMoveToTop = () => {
  return (useEffect(() => {
    window.scrollTo(0, 0);
  }, []))
};

export default useMoveToTop;